var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.zulLinkData),function(linkData,i){return _c('p',{key:i},[(linkData.permitText)?_c('span',[_vm._v(_vm._s(linkData.permitText)+" ")]):_vm._e(),_c('a',{attrs:{"href":linkData.link,"target":"_blank"}},[[_vm._v(" "+_vm._s(linkData.linkText || _vm.$t('singleResult.default.linkTemplate'))+" ")]],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }